// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UAVariableValue } from './UAVariableValue';
import {
    UAVariableValueFromJSON,
    UAVariableValueFromJSONTyped,
    UAVariableValueToJSON,
    UAVariableValueToJSONTyped,
} from './UAVariableValue';
import type { UAVariableStatusCode } from './UAVariableStatusCode';
import {
    UAVariableStatusCodeFromJSON,
    UAVariableStatusCodeFromJSONTyped,
    UAVariableStatusCodeToJSON,
    UAVariableStatusCodeToJSONTyped,
} from './UAVariableStatusCode';

/**
 * 
 * @export
 * @interface UAVariable
 */
export interface UAVariable {
    /**
     * 
     */
    serverTimestamp: Date;
    /**
     * 
     */
    sourceTimestamp?: Date;
    /**
     * 
     */
    statusCode: UAVariableStatusCode;
    /**
     * 
     */
    value: UAVariableValue;
}



/**
 * Check if a given object implements the UAVariable interface.
 */
export function instanceOfUAVariable(value: object): value is UAVariable {
    if (!('serverTimestamp' in value) || value['serverTimestamp'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UAVariableFromJSON(json: any): UAVariable {
    return UAVariableFromJSONTyped(json, false);
}

export function UAVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAVariable {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimestamp': (new Date(json['serverTimestamp'])),
        'sourceTimestamp': json['sourceTimestamp'] == null ? undefined : (new Date(json['sourceTimestamp'])),
        'statusCode': UAVariableStatusCodeFromJSON(json['statusCode']),
        'value': UAVariableValueFromJSON(json['value']),
    };
}

export function UAVariableToJSON(json: any): UAVariable {
    return UAVariableToJSONTyped(json, false);
}

export function UAVariableToJSONTyped(value?: UAVariable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimestamp': value['serverTimestamp'].toISOString(),
        'sourceTimestamp': value['sourceTimestamp'] == null ? value['sourceTimestamp'] : value['sourceTimestamp'].toISOString(),
        'statusCode': UAVariableStatusCodeToJSON(value['statusCode']),
        'value': UAVariableValueToJSON(value['value']),
    };
}

